export default __webpack_public_path__ + "static/adapters_m-cec30f843bdadc31779a8755ccf6c8d5.png";